import { makePublicUrl } from 'app/utils/publicUrl'

import { StyledBGImage, StyledBGImageWrapper } from './styles'

function LoginBgImage() {
  return (
    <>
      <StyledBGImageWrapper>
        <StyledBGImage
          src={makePublicUrl('images/loginBgImage.jpg')}
          alt="Login page background image"
        />
      </StyledBGImageWrapper>
    </>
  )
}

export default LoginBgImage
